/**
 * Spacer-komponent der bruges til at tilføje vertikal eller horisontal afstand mellem elementer
 * @param {string} size - Standard afstand i pixels (default: '5px')
 * @param {boolean} vertical - Om afstanden skal være vertikal (default: true)
 * @param {boolean} horizontal - Om afstanden skal være horisontal
 * @param {boolean} s - Small afstand (10px)
 * @param {boolean} m - Medium afstand (20px)
 * @param {boolean} l - Large afstand (30px)
 * @param {boolean} xl - Extra large afstand (60px)
 * @param {boolean} xxl - Extra extra large afstand (80px)
 */
const Spacer = ({size = '5px', vertical = true, horizontal, s, m, l, xl, xxl}) => {
   
    if (s) size = '10px'
    if (m) size = '20px'
    if (l) size = '30px'
    if (xl) size = '60px'
    if (xxl) size = '80px'

    let spacerStyle
    if (vertical) {
        spacerStyle = { height: size }
    } else if (horizontal) {
        spacerStyle = { width: size }
    }

    return <div style={spacerStyle} />
    
}

export default Spacer